import {Component, OnInit, OnDestroy , ViewChild} from '@angular/core';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal, ModalDismissReasons, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

import {Column, GridOption, AngularGridInstance, Formatters} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';


@Component({
  selector: 'app-category-lavel-mapping',
  templateUrl: './category-lavel-mapping.component.html',
  styleUrls: ['./category-lavel-mapping.component.css']
})
export class CategoryLavelMappingComponent implements OnInit, OnDestroy {
  masterName: string;
  clients: any[];
  clientId: number;

  displayData: any;
  isError = false;
  errorMessage: string;
  respObject: any;
  totalData: number;
  nextOffset: number;
  previousOffset: number;
  collectionSize: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private baseFlag: any;
  private userAuth: Subscription;
  private notifier: NotifierService;
  add = false;
  del = false;
  edit = false;
  view = false;
  tickets = [];
  headers = [];
  ticketSelected: number;
  category_header_id: number;
  category_level: number;
  isradio = true;
  isSaveDisable = true;
  type: number;
  dataLoaded:boolean;
  showSearch = true;
  isLoading = false;
  searchData: FormControl = new FormControl();
  categrySelected: any;
  categrys: any;
  
  level: string;
  showExportBtn = true;
  dataExcel= [];
  @ViewChild('scarch_content') private scarch_content;
  private searchModalReference: NgbModalRef;




  constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
              private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      // console.log(item);
      switch (item.type) {
        case 'change':
          console.log('changed');
          if (!this.messageService.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {
            if (confirm('Are you sure?')) {
              item.createdBy = this.messageService.getUserId();
              item.client_id = this.clientId;
            }
          }
          break;
        case 'delete':
          // console.log('deleted');
          if (!this.messageService.del) {
            this.notifier.notify('error', 'You do not have delete permission');
          } else {
            if (confirm('Are you sure?')) {
            }
          }
          break;
      }
    });
  }

  ngOnInit() {
    this.dataLoaded=false;
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.displayData = {
      pageName: 'Maintain Category Level Mapping',
      openModalButton: 'Add',
      searchModalButton: 'Search',
      breadcrumb: 'Category Level Mapping',
      folderName: 'Category Level Mapping',
      tabName: 'Category Level Mapping',
      exportBtn: 'Export to excel'

    };

    const columnDefinitions = [
      // {
      //   id: 'delete',
      //   field: 'id',
      //   excludeFromHeaderMenu: true,
      //   formatter: Formatters.deleteIcon,
      //   minWidth: 30,
      //   maxWidth: 30,
      // },
      // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
      {id: 'categoryHeader', name: 'Category header', field: 'header_name', sortable: true, filterable: true},
      {id: 'categoryLavel', name: 'Category level', field: 'category_level', sortable: true, filterable: true},
      {id: 'ticketType', name: 'Ticket type', field: 'ticket_type', sortable: true, filterable: true}
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
        this.view = auth[0].viewFlag;
        this.add = auth[0].addFlag;
        this.edit = auth[0].editFlag;
        this.del = auth[0].deleteFlag;
        this.clientId = auth[0].clientId;
        this.baseFlag = auth[0].baseFlag;
        this.onPageLoad();
      });
    }
  }

  onPageLoad() {
    this._rest.getTicketType(this.clientId).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
        this.tickets = this.respObject.details;
        this.ticketSelected = 0;
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', JSON.stringify(err));
    });
    this.getTableData();
  }

  exportToExcel() {
    // console.log("okkk" +this.clientId);
    this._rest.getAllMapClientWithCategoryLevel(this.clientId).subscribe((res1) => {
        this.respObject = res1;
        if (this.respObject.success) {
            this.dataExcel = this.respObject.details;
            // console.log("true"+ JSON.stringify(this.dataExcel));
            this.messageService.exportAsExcelFile(this.dataExcel);
        } else {
            this.notifier.notify('error', this.respObject.errorMessage);
        }
    }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
}


  openModal(content) {
    if (!this.messageService.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.masterName = '';
      this.modalService.open(content, {size: 'sm'}).result.then((result) => {
      }, (reason) => {

      });
    }
  }

  searchModal() {
    
      this.categrySelected = '';
      this.searchModalReference = this.modalService.open(this.scarch_content);
      this.searchModalReference.result.then((result) => {
      }, (reason) => {

      });

  }
  
search() {
  this._rest.searchAllMapClientWithCategoryLevel(this.categrySelected, this.clientId).subscribe((res1) => {
    this.respObject = res1;
    this.isLoading = false;
    if (this.respObject.success) {
        this.categrys = this.respObject.details;
        this.messageService.setTotalData(this.categrys.length);
        this.messageService.setGridData(this.categrys);
        this.searchModalReference.close();

    } else {
        this.notifier.notify('error', this.respObject.errorMessage);
    }
}, (err) => {
    this.isLoading = false;
    this.notifier.notify('error', this.messageService.SERVER_ERROR);
});
  
}

  onButtonChange(selectedButton) {
    this.category_header_id = selectedButton.value.id;
    this.category_level = selectedButton.value.sequence_no;
    this.isSaveDisable = false;
  }

  onTicketChange(selectedIndex: any) {
    this.type = this.tickets[selectedIndex].id;
    const data = {
      'ticket_type': this.type,
      'client_id': this.clientId
    };
    this._rest.getAttributesHeaderMstTicketTypewise(data).subscribe((res1) => {
      this.respObject = res1;
      this.isSaveDisable = true;
      if (this.respObject.success) {
        this.isradio = false;
        this.isError = false;
        this.headers = this.respObject.details;
      } else {
        this.isradio = true;
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = err;
    });
  }

  save() {
    const data = {
      client_id: this.clientId,
      ticket_type: this.type,
      user_id: this.messageService.getUserId(),
      category_header_id: this.category_header_id,
      category_level: this.category_level
    };
    this._rest.insertWFCGeneratedFor(data).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.nextOffset = 0;
                this.page_no = 0;
                this.getTableData();
                this.headers = [];
                this.ticketSelected = 0;
                this.notifier.notify('success', 'Record inserted successfully');
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = err;
        });
  }

  getTableData() {
    if (!this.messageService.view) {
      this.notifier.notify('error', 'You do not have view permission');
    } else {
      this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  getData(paginationObj) {
    const offset = paginationObj.offset;
    const paginationType = paginationObj.paginationType;
    this.dataLoaded=false;
    this._rest.getWFCGeneratedDetails(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
      this.respObject = res;
      this.executeResponse(this.respObject, offset, paginationType);
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  executeResponse(respObject, offset, paginationType) {
    if (respObject.success) {
      this.dataLoaded=true;
      if (offset === 0) {
        this.collectionSize = respObject.details.totalData[0].count;
        this.totalPage = respObject.details.totalPage;
      }
      if (!this.isEmpty(respObject.details.dataObj)) {
        const data = respObject.details.dataObj;
        this.nextOffset = respObject.details.nextOffset;
        this.previousOffset = respObject.details.previousOffset;
        this.totalData = data.length;
        this.messageService.setTotalData(data.length);
        this.messageService.setGridData(data);
        if (paginationType === 'next') {
          this.page_no = this.page_no + 1;
        } else if (paginationType === 'prev') {
          this.page_no = this.page_no - 1;
        } else if (paginationType === '' && this.page_no === 0) {
          this.page_no = this.page_no + 1;
        }
      } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
        this.nextOffset = 0;
      } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
        this.previousOffset = 0;
      } else if (paginationType === '' && this.page_no === 0) {
        this.page_no = this.page_no + 1;
      }
    } else {
      this.notifier.notify('error', respObject.errorMessage);
    }
  }

  onPageSizeChange(value: any) {
    this.page_no = 0;
    this.nextOffset = 0;
    this.pageSize = value;
    this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }

  ngOnDestroy(): void {
    if (this.userAuth) {
      this.userAuth.unsubscribe();
    }
  }

}
